class HeaderDrawerController extends window.StimulusController {
  static targets = [
    "drawer",
    "panel",
    "panelTitle",
    "backButton",
    "logo",
    "titleText",
    "closeButton",
  ];

  connect() {
    document.addEventListener(
      "drawer:toggle",
      this.toggleVisibility.bind(this),
    );
  }

  disconnect() {
    document.removeEventListener(
      "drawer:toggle",
      this.toggleVisibility.bind(this),
    );
  }

  toggleVisibility() {
    this.drawerTarget.classList.toggle("tw-translate-x-[-100%]");
    this.drawerTarget.classList.toggle("tw-translate-x-0");
    document.body.classList.toggle("overflow-hidden");

    if (this.drawerTarget.classList.contains("tw-translate-x-0")) {
      this.element.classList.remove("tw-opacity-0", "tw-pointer-events-none");
      if (this.hasCloseButtonTarget) {
        this.closeButtonTarget.focus();
      }
    } else {
      setTimeout(() => {
        this.element.classList.add("tw-opacity-0", "tw-pointer-events-none");
      }, 300);
    }

    this.resetPanels();
  }

  preventClickPropagation(event) {
    event.stopPropagation();
  }

  openPanel(event) {
    const level = parseInt(event.currentTarget.dataset.level);
    const title = event.currentTarget.dataset.title;
    const parentTitle =
      event.currentTarget.closest("[data-headerDrawer-target='panel']")?.dataset
        .title || "root";

    this.currentLevel = level;
    this.currentTitle = title;
    this.currentParentTitle = parentTitle;

    this.panelTargets.forEach((panel) => {
      const panelLevel = parseInt(panel.dataset.level);
      const panelTitle = panel.dataset.title;
      const panelParent = panel.dataset.parent || "root";

      const isCurrent =
        panelLevel === level &&
        panelTitle === title &&
        (panelLevel === 1 || panelParent === parentTitle);

      if (panelLevel === level) {
        panel.style.transform = isCurrent
          ? "translateX(0)"
          : "translateX(100%)";
      } else if (panelLevel < level) {
        panel.style.transform = "translateX(-100%)";
      } else {
        panel.style.transform = "translateX(100%)";
      }
    });

    if (this.hasLogoTarget) this.logoTarget.classList.add("tw-hidden");
    if (this.hasTitleTextTarget) {
      this.titleTextTarget.classList.remove("tw-hidden");
      this.titleTextTarget.textContent = title;
    }
    if (this.hasBackButtonTarget)
      this.backButtonTarget.classList.remove("tw-hidden");
  }

  goBack() {
    if (this.currentLevel === 0) return;

    const prevLevel = this.currentLevel - 1;
    const targetTitle =
      this.currentLevel === 2 ? this.currentParentTitle : null;

    this.panelTargets.forEach((panel) => {
      const level = parseInt(panel.dataset.level);
      const panelTitle = panel.dataset.title;

      if (level === prevLevel) {
        const shouldShow =
          this.currentLevel === 2 ? panelTitle === targetTitle : level === 0;

        panel.style.transform = shouldShow
          ? "translateX(0)"
          : "translateX(100%)";

        if (shouldShow && this.hasTitleTextTarget) {
          this.titleTextTarget.textContent = panelTitle || "";
        }

        if (shouldShow && level === 0 && this.hasLogoTarget) {
          this.logoTarget.classList.remove("tw-hidden");
          this.titleTextTarget.classList.add("tw-hidden");
          this.backButtonTarget.classList.add("tw-hidden");
        }
      }

      if (level >= this.currentLevel) {
        panel.style.transform = "translateX(100%)";
      }
    });

    this.currentLevel = prevLevel;
  }

  resetPanels() {
    this.panelTargets.forEach((panel) => {
      const level = parseInt(panel.dataset.level);
      panel.style.transform =
        level === 0 ? "translateX(0)" : "translateX(100%)";
    });

    if (this.hasLogoTarget) this.logoTarget.classList.remove("tw-hidden");
    if (this.hasTitleTextTarget)
      this.titleTextTarget.classList.add("tw-hidden");
    if (this.hasBackButtonTarget)
      this.backButtonTarget.classList.add("tw-hidden");

    this.currentLevel = 0;
    this.currentTitle = null;
    this.currentParentTitle = null;
  }
}

Stimulus.register("headerDrawer", HeaderDrawerController);
